import { useEffect } from 'react'

import { useAuth } from 'components/AuthProvider'

import { Navigate, Outlet, useLocation } from 'react-router-dom'

export const PublicRouteGuard = (): JSX.Element => {
  const { user } = useAuth()

  useEffect(() => {
    if (document.body.classList.contains('hide-grecaptcha') === true) {
      document.body.classList.remove('hide-grecaptcha')
    }
  }, [])

  if (user) {
    return <Navigate to='/dashboard' replace />
  }

  return <Outlet />
}

export const AuthenticatedRouteGuard = (): JSX.Element => {
  const { user } = useAuth()
  const location = useLocation()

  useEffect(() => {
    if (document.body.classList.contains('hide-grecaptcha') === false) {
      document.body.classList.add('hide-grecaptcha')
    }
  }, [])

  if (!user) {
    return <Navigate to='/login' state={{ from: location }} replace />
  }

  return <Outlet />
}
